import SearchBarWithResults from './SearchBarWithResults';

export default SearchBarWithResults;
